export const RESET = 'COUNTRY_UPDATE_RESET'
export const SET_ERROR = 'COUNTRY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'COUNTRY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'COUNTRY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'COUNTRY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'COUNTRY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'COUNTRY_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'COUNTRY_UPDATE_FILES'
